<template>
  <div class="main-wrapper">
    <!-- <h1>Dit is een layout text!</h1> -->
    <slot />
  </div>
</template>

<script>
export default {
  props: {},
  data: () => ({})
}
</script>
